"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var MediaManagerImage_1 = require("@sportnet/ui/lib/MediaManagerImage");
var utils_1 = require("@sportnet/ui/lib/MediaManagerPhotoEditor/utils");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = require("../../../theme/styled-components");
var Match_1 = tslib_1.__importDefault(require("./Match"));
var C = function (_a) {
    var theme = _a.theme, data = _a.data, renderEmpty = _a.renderEmpty;
    if (!data.matchId && renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('matchOverview'));
    }
    if (data.data) {
        var backgroundImage = data.backgroundImage
            ? MediaManagerImage_1.getMediaManagerUrl(data.backgroundImage, utils_1.MAX_SIZE, utils_1.MAX_SIZE, 'media')
            : undefined;
        return (React.createElement("div", { className: "content-widget-matchOverview" },
            React.createElement(Match_1["default"], { theme: theme, match: data.data.match, lastIndex: true, sportSectorsPhases: data.data.sportSectorPhases, fullWidth: true, settings: data.data.match.settings, verbose: true, backgroundImage: backgroundImage })));
    }
    return null;
};
exports["default"] = styled_components_1.withTheme(C);
